import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { StepChannel } from './types';

interface WizardChannelContextValue {
  wizardId: string;
  activeChannel: StepChannel | null;
}

const WizardChannelContext = createContext<WizardChannelContextValue | null>(null);

export interface WizardChannelProviderProps {
  wizardId: string;
  activeChannel: StepChannel | null;
  children: ReactNode;
}

export function WizardChannelProvider({
  wizardId,
  activeChannel,
  children,
}: WizardChannelProviderProps): JSX.Element {
  const value = useMemo<WizardChannelContextValue>(
    () => ({ wizardId, activeChannel }),
    [wizardId, activeChannel],
  );

  return (
    <WizardChannelContext.Provider value={value}>
      {children}
    </WizardChannelContext.Provider>
  );
}

export function useWizardChannelContext(): WizardChannelContextValue | null {
  return useContext(WizardChannelContext);
}
